/**
 * For website prototype to embed jwplayer video
 *
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('pitch.app')
.directive('satvVideoPlayer', ['$sce',
    function($sce) {

    "use strict";

    return {
        restrict: 'A',
        transclude: true,
        scope: {
            src: '@',
            height: '=',
            autostart: '=',
            aspectratio: '='
        },
        link: function($scope, elem, attr, ctrl) {
            $scope.elementId = 'satv-video-player-' + Math.floor((Math.random()*6)+1);

            var videoEl = angular.element(elem[0].querySelector('video'));

            $scope.$watch('src', function(resourceUrl) {
                $scope.isPlaying = false;

                if (resourceUrl) {
                    $scope.selectedVideoUrl = $sce.trustAsResourceUrl(resourceUrl);

                    videoEl[0].addEventListener('play', function() {
                        setTimeout(function() {
                            $scope.isPlaying = true;
                            $scope.$apply();
                        }, 3000);
                    });

                    //add labeled by attribute for accessability
                    if (attr.labeledBy) {
                        videoEl.attr('aria-labelledby', attr.labeledBy);
                    }
                }
            });
        },
        template: '<div class="video-player-wrapper aspect-height" style="padding-bottom:[[::aspectratio]]">' +
                      '<video class="player container-wrapper" id="[[::elementId]]" autoplay="autoplay" controls src="[[selectedVideoUrl]]" style="background-color:black;"></video>' +
                      '<div class="fade-out" ng-hide="isPlaying" ng-transclude></div>' +
                  '</div>'
    };
}])
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/videoPlayer.js